import React from "react";
import '../../assets/styles/ClientShared.css';

const Guides = () => {
  const guides = [
    {
      category: "Uploading Images: Best Practices",
      content: [
        "For the best website performance, use optimized image formats:",
        <strong> "JPEG: Best for photographs and complex images, balancing quality and file size." </strong>,
        <strong> "PNG: Great for images requiring transparency but results in larger file sizes." </strong>,
        <strong> "WebP: A modern format with better compression and quality than JPEG or PNG." </strong>,
        <strong> "SVG: Ideal for logos and icons since it maintains quality at any size." </strong>,
        "For faster loading speeds, ensure images are under 500KB and use dimensions appropriate for the website layout. You can use free tools like TinyPNG or Squoosh to optimize images before uploading."
      ],
    },
    {
      category: "Running Ads for Your New Website",
      content: [
        "If you want to drive traffic to your new website, consider these advertising platforms:",
        <strong> "Google Ads: Best for search engine visibility with keyword targeting." </strong>,
        <strong> "Facebook & Instagram Ads: Great for visual promotions and audience targeting." </strong>,
        <strong> "TikTok Ads: Ideal for engaging, short-form video content." </strong>,
        <strong> "LinkedIn Ads: Best for B2B and professional networking." </strong>,
        "To get started, check out resources on Google Ads Help Center, Facebook Business Manager, and YouTube tutorials for ad setup and targeting."
      ],
    },
    {
      category: "Setting Up Your Google Business Profile",
      content: [
        "A Google Business Profile helps your business appear in Google Search and Maps, making it easier for potential customers to find you.",
        "Follow these steps to set up your profile:",
        "1. Go to ",
        <a href="https://www.google.com/business/" target="_blank" rel="noopener noreferrer">Google Business Profile</a>,
        "2. Click 'Manage Now' and sign in with your Google account.",
        "3. Enter your business name and category.",
        "4. Add your location if you have a physical store, or select 'No location' for online businesses.",
        "5. Enter your contact details (phone number, website).",
        "6. Complete the verification process (usually via email, phone, or postcard).",
        "7. Optimize your profile by adding images, business hours, and a description.",
        "Having a Google Business Profile increases trust and makes it easier for customers to contact you."
      ],
    },
    {
      category: "Analyzing Your Website & Navigating Firebase",
      content: [
        "To monitor and analyze your website's performance, use the following tools:",
        <strong> "Google Analytics: Tracks visitor behavior, traffic sources, and popular pages." </strong>,
        <strong> "Google Search Console: Helps monitor search engine rankings and indexing issues." </strong>,
        <strong> "Firebase Console: If your website uses Firebase, navigate to:" </strong>,
        "  1. Authentication - Manage user logins and access.",
        "  2. Firestore Database - View and update website data in real-time.",
        "  3. Hosting - See website deployment history and manage versions.",
        "  4. Analytics - Track user engagement and app performance.",
        "Regularly checking these tools will help you improve your website and understand visitor behavior."
      ],
    },
  ];

  return (
    <div className="cp-page">
      <div className="cp-page-header">
        <p className="cp-eyebrow">Client Portal</p>
        <h1 className="cp-title">Guides & Tutorials</h1>
        <p className="cp-subtitle">Essential guides to help you manage and grow your website.</p>
      </div>
      {guides.map((section, index) => (
        <div key={index} className="cp-section" style={{ marginBottom: '20px' }}>
          <div className="cp-section-header">
            <h2 className="cp-section-title">{section.category}</h2>
          </div>
          <div className="cp-section-body">
            <ul className="cp-list">
              {section.content.map((item, idx) => (
                <li key={idx} className="cp-list-item">{item}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Guides;
